// extracted by mini-css-extract-plugin
module.exports = {"kidsAccountNavWrapper":"Br","hidden":"Bs","menuBackground":"Bt","avatar":"Bu","header":"Bv","accountNavAvatar":"Bw","buttonPlaceholder":"Bx","accountLinks":"By","accountLink":"Bz"};